import type { OptionIndication } from '../../../../../api/submissions/submission-coverages.types';

/**
 * The display-only price captured when an option is saved. A referred quote has no price to
 * show, so it carries none.
 */
export const buildIndication = (
  totalPremium: number | null | undefined,
  refers: boolean | undefined,
  ratedAt: Date = new Date()
): OptionIndication | null => {
  if (refers || totalPremium == null || Number.isNaN(totalPremium)) {
    return null;
  }
  return { totalPremium, ratedAt: ratedAt.toISOString() };
};
